// useUserMenus.js
import { useEffect, useState } from 'react';
import axios from '../api/axios';

export const useUserMenus = (userId) => {
  const [menus, setMenus] = useState(() => {
    const cached = localStorage.getItem(`menus_${userId}`);
    return cached ? JSON.parse(cached) : [];
  });
  const [loading, setLoading] = useState(!menus.length);

  const fetchMenus = async (force = false) => {
    if (!userId) return;
    if (!force && menus.length) return; // skip if already loaded and not forced

    setLoading(true);
    try {
      const res = await axios.get(`/users/${userId}/menus`);
      setMenus(res.data);
      localStorage.setItem(`menus_${userId}`, JSON.stringify(res.data));
    } catch (err) {
      console.error('Failed to load user menus', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchMenus();
  }, [userId]);

  return {
    menus,
    loading,
    refetch: () => fetchMenus(true) // allow manual reload
  };
};

export function buildMenuTree(pages, parentId = null) {
  return pages
    .filter(page => page.parent_id === parentId && page.show_in_menu) // ✅ filter here
    .map(page => ({
      ...page,
      children: buildMenuTree(pages, page.id)
    }));
}
